import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import checkinD1 from '../../../assets/placeholders/checkinD1.jpg'
import checkinD2 from '../../../assets/placeholders/checkinD2.jpg'
import checkinD3 from '../../../assets/placeholders/checkinD3.jpg'
import './checkinDone.less'
import { AppState } from '../../../reducers'
import { TAL } from '../../../constants/uiConfig'

const EXIT_TIMEOUT = 10000

interface DispatchProps {
  setUI: (ui: UI) => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setUI: (ui: UI) => dispatch(setUIForwardAction(ui)),
})

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
})
type StateProps = ReturnType<typeof mapStateToProps>

type Props = StateProps & DispatchProps

const Component: React.FC<Props> = ({ setUI, reservation }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => setUI(UI.MAIN), EXIT_TIMEOUT)
    return () => clearTimeout(timer)
  }, [setUI])

  return (
    <React.Fragment>
      <Header />
      <div className="checkin-done">
        <div className="checkin-done-title" dangerouslySetInnerHTML={{ __html: t('checkinDone') }}></div>
        <div className="checkin-done-content">
          <div className="images-and-text">
            <div className="checkinD-images">
              <img className="checkinD" src={checkinD1} alt="checkinD" />
              <img className="checkinD" src={checkinD2} alt="checkinD" />
              <img className="checkinD" src={checkinD3} alt="checkinD" />
            </div>
            <div className="text">
              <div className="text-field">
                <div dangerouslySetInnerHTML={{ __html: t('checkinDoneTakeSeawaybill') }}></div>
              </div>
              <div className="text-field">
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('checkinDoneGetCabinKey'),
                  }}
                ></div>
              </div>
              <div className="text-field">
                {t('checkinDoneDriveTo')}
                <div className="gate-text">
                  {reservation && reservation.route.portFrom === TAL ? t('gateNameAtTalling') : t('gateName')}
                </div>
              </div>
            </div>
          </div>

          <button className="main-button" onClick={() => setUI(UI.MAIN)}>
            {t('exit')}
          </button>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
